import React from 'react';
import { Modal } from 'react-responsive-modal';
import { useForm } from "react-hook-form";
import useToast from 'hooks/useToast';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import useCampaigns from 'hooks/useCampaigns';
import useCampaignDetail from 'hooks/useCampaignDetail';

const UpdatePromoCodeNamePopup = (props) => {
    const { open, close, campaignDetailID } = props;
    const toast = useToast();
    const { dateRangeID, updatePromoCodeName } = useCampaigns();
    
    const campaignID = parseInt(campaignDetailID);
    const { data: campaignDetail } = useCampaignDetail(campaignID, dateRangeID);
    const Detail = campaignDetail?.CampaignDetail?.PromoCode ?? null;
    
    const editNameForm = useForm(
        { 
            mode: "onSubmit",         
            reValidateMode: "onSubmit",
            defaultValues: { title: Detail?.Code?? '' },
            resolver: yupResolver(Yup.object().shape({title: Yup.string().trim().required("Campaign name is required")})) 
        });

    const editNameFormSubmitHandler = (frmData) => {
        if (updatePromoCodeName.isLoading) return;
        if (!campaignDetailID || isNaN(campaignDetailID) || campaignID < 1) return;
        updatePromoCodeName.mutateAsync({ 
            id: campaignDetailID,
            code: frmData.title, 
        })
        .then(()=>{ close(); })
        .catch(err => toast.error("Failed to edit promo code", err));
    };

    return (
        <Modal classNames={{ overlay: 'add-promo-code-overlay', modal: 'add-promo-code-modal' }} open={open} onClose={close} center>
            <div className="add-promo-code">
                <h3>Edit promo code</h3>
                <form onSubmit={editNameForm.handleSubmit(editNameFormSubmitHandler)}>
                    <div className="link-field">
                        <input type="text"
                            placeholder='enter your promo code...'
                            {...editNameForm.register("title")}
                        />
                        <p className="btn grey"><input type="submit" value="Save" disabled={updatePromoCodeName.isLoading} /></p>
                    </div>
                    {editNameForm.formState.errors?.title?.message && <span className="error-msg" style={{display: 'block'}}>{editNameForm.formState.errors?.title?.message}</span>}
                </form>
            </div>
        </Modal>
    );
};

export default UpdatePromoCodeNamePopup;
